import { supabase } from "../../lib/supabase";

export async function fetchSignaturesForContract(contract_id) {
  const { data, error } = await supabase
    .from("drive_signatures")
    .select("*")
    .eq("contract_id", contract_id)
    .order("created_at");
  if (error) throw error;
  return data;
}

export async function createSignatureRequest(contract_id, signer_role, signer_label) {
  const { data, error } = await supabase
    .from("drive_signatures")
    .insert([{ contract_id, signer_role, signer_label }])
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function getSignatureTask(token) {
  const { data, error } = await supabase.rpc("get_signature_task", { t: token });
  if (error) throw error;
  return (data && data[0]) || null;
}

export async function submitSignature(token, signer_name, signature_png) {
  const { data, error } = await supabase.rpc("submit_signature", {
    t: token,
    signer: signer_name,
    sig: signature_png,
  });
  if (error) throw error;
  return data;
}
